import React from 'react';
import { Home, RotateCcw } from 'lucide-react';

interface MapNavigationProps {
  isExploring: boolean;
  hasLocation: boolean;
  onReturnToLocation: () => void;
  onReset: () => void;
  className?: string;
}

/**
 * Floating navigation controls for map exploration
 */
export const MapNavigation: React.FC<MapNavigationProps> = ({
  isExploring,
  hasLocation,
  onReturnToLocation,
  onReset,
  className = '',
}) => {
  // Only show navigation when user has a location and is exploring
  if (!hasLocation || !isExploring) {
    return null;
  }

  return (
    <div className={`absolute bottom-4 right-4 z-[1000] flex flex-col gap-2 ${className}`}>
      {/* Return to My Location */}
      <button
        onClick={onReturnToLocation}
        className="flex items-center gap-2 bg-white hover:bg-gray-50 text-gray-700 px-4 py-2 rounded-lg shadow-lg border border-gray-200 transition-all duration-200 hover:shadow-xl group"
        title="Return to your location"
      >
        <Home className="w-4 h-4 text-amber-500 group-hover:text-amber-600" />
        <span className="text-sm font-medium whitespace-nowrap">Return to My Location</span>
      </button>

      {/* Reset */}
      <button
        onClick={onReset}
        className="flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg shadow-lg transition-all duration-200 hover:shadow-xl group"
        title="Reset to initial view"
      >
        <RotateCcw className="w-4 h-4 group-hover:rotate-180 transition-transform duration-300" />
        <span className="text-sm font-medium whitespace-nowrap">Reset</span>
      </button>
    </div>
  );
};

export default MapNavigation;